import { combineReducers } from 'redux'
import { injectReducer } from '../../../../store/reducers'
import { injectSaga, cancelSaga } from '../../store/sagas'

export default (store) => ({
  path: 'apply-defaults',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ApplyDefaults = require('./containers/ApplyDefaultsContainer').default
      const applyDefaultsReducer = require('./modules/applyDefaults').default
      const saga = require('./modules/applyDefaults').mainSaga

      injectReducer(store, {
        key: 'applyDefaults',
        reducer: combineReducers({
          button: applyDefaultsReducer
        })
      })

      injectSaga(store, { key: 'applyDefaults', saga })

      /*  Return getComponent   */
      cb(null, ApplyDefaults)

    /* Webpack named bundle   */
    }, 'applyDefaults')
  },

  onLeave() {
    cancelSaga(store, 'applyDefaults')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Button/routes/ApplyDefaults/index.js